import { TicketDetails } from "store/apis/chat";
import { ChatTicketCard } from "../ChatTicketCard";
import { SmallEmptyOpenBox } from "../SmallEmptyOpenBox";

export const TicketList = ({
  ticketMessages,
  resolved,
  channelUrl,
  emptyStateText,
}: {
  ticketMessages: TicketDetails[];
  resolved?: boolean;
  channelUrl: string;
  emptyStateText: string;
}) => {
  const noTicketFound = !ticketMessages || ticketMessages.length === 0;

  if (noTicketFound) {
    return (
      <div className="t-h-full t-w-full t-flex t-justify-center t-items-center">
        <SmallEmptyOpenBox text={emptyStateText} />
      </div>
    );
  }

  return (
    <div className="t-flex t-flex-col t-gap-4 t-pb-5">
      {ticketMessages.map((ticket) => (
        <ChatTicketCard
          title={ticket.ticket_name || ""}
          description={ticket.ticket_title || ""}
          ticketId={ticket.ticket_uuid}
          key={ticket.ticket_uuid}
          resolved={resolved}
          channelUrl={channelUrl}
        />
      ))}
    </div>
  );
};
